import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { memo, forwardRef } from "react";
import Icon from "../../Icon/Icon";
var BoxDefaultPostalIcon = /*#__PURE__*/forwardRef(function (properties, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, properties), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.655 4.572l1.863-1.024a1 1 0 01.964 0l6.405 3.523-2.363 1.3-6.87-3.799zm7.845 5.544L20 8.741v6.985a1 1 0 01-.518.876L13 20.168v-7.719c.32-.082.631-.205.928-.368l1.572-.865V13a1 1 0 002 0v-2.884zM11 12.45a3.996 3.996 0 01-.928-.368L4 8.741v6.985a1 1 0 00.518.876L11 20.168v-7.719zm.036-2.12L5.113 7.07l2.47-1.359 6.869 3.798-1.488.819a2 2 0 01-1.928 0zm-.482-8.534l-7 3.85A3 3 0 002 8.274v7.452a3 3 0 001.554 2.629l7 3.85a3 3 0 002.892 0l7-3.85A3 3 0 0022 15.726V8.274a3 3 0 00-1.554-2.629l-7-3.85a3 3 0 00-2.892 0z",
    fill: "currentColor"
  }));
});
export default /*#__PURE__*/memo(BoxDefaultPostalIcon);